import React from 'react';
import { Box, Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { tokens } from '../theme';

/**
 * Leave-policy wizard stepper. Matches the attendance stepper visually.
 * `active` is the current step's label (string); earlier steps render as done.
 */
const STEPS = ["Policy Details", "Assign Policy", "Rules", "Review"];

const ActiveBar = ({ active }) => {
  // `active` may be a single step label (string) or a list of reached steps (array)
  const reached = Array.isArray(active) ? active : [active];
  let currentIndex = 0;
  STEPS.forEach((label, i) => { if (reached.includes(label)) currentIndex = i; });

  return (
    <Stack direction="row" alignItems="center" sx={{ flex: 1, minWidth: 0, py: "0.5rem", mr: "1rem", flexWrap: "wrap", rowGap: "0.5rem" }}>
      {STEPS.map((label, i) => {
        const done = i < currentIndex;
        const current = i === currentIndex;
        const dotColor = done || current ? tokens.accent : tokens.border;
        const textColor = current ? tokens.text : done ? tokens.accent : tokens.textMuted;
        const isLast = i === STEPS.length - 1;
        return (
          <React.Fragment key={label}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ flexShrink: 0 }}>
              <Box sx={{
                width: "1.75rem", height: "1.75rem", borderRadius: "50%",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "0.8125rem", fontWeight: 600, flexShrink: 0,
                background: done ? tokens.accent : current ? `${tokens.accentTint}` : tokens.surfaceSubtle,
                color: done ? tokens.onPrimary : current ? tokens.accent : tokens.textMuted,
                border: `1px solid ${dotColor}`,
              }}>
                {done ? <CheckIcon sx={{ fontSize: "1rem" }} /> : i + 1}
              </Box>
              <Box sx={{ fontSize: "0.875rem", fontWeight: current ? 600 : 500, color: textColor, whiteSpace: "nowrap" }}>
                {label}
              </Box>
            </Stack>
            {!isLast && (
              <Box sx={{ flex: 1, minWidth: "1rem", maxWidth: "5rem", height: "2px", mx: "0.75rem", background: done ? tokens.accent : tokens.border }} />
            )}
          </React.Fragment>
        );
      })}
    </Stack>
  );
};

export default ActiveBar;
